<template>

      <div class="div-playlist">
<b-row>
<b-col cols="6">
  <h1>{{playlist.name | replaceDCU}}</h1>
      <img :src="playlist.images[0].url" style="max-width: 90%;margin-bottom: 15px;" />
      <p style="margin-top: 15px;text-align: left;font-family: 'Montserrat'; font-size: 10px !important;">
        Curated by <br /> <span style="font-size: 24px; font-weight: bold;">{{playlist.owner.display_name}}</span>
      </p>
</b-col>
<b-col cols="6">
<ul v-for="(record, index) in playlist.tracks.items" :key="index" style="text-align: left;">
        <li v-if="record.track.artists">

          <span style="font-size: 1.6rem;font-weight: 300;">
            <span style="position: relative; top: -10px;left:-10px;font-size: 1.1rem;">
            {{index+1}}
          </span>
            {{record.track.artists[0].name }}
          </span>
          <span style="font-size: 1.2rem;font-family: 'Montserrat', sans-serif;margin-left: 5px;">
            {{record.track.name}}
          </span>
        </li>
      </ul>
</b-col>
</b-row>

<hr />


      </div>


</template>

<script>
export default {
  name: "Playlist",
  props: {
    playlist: Object,
  },
  filters: {
    replaceDCU: function(value) {
      return value.replace("Das Catch Up", "");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

li {
  list-style-type: none;
}

.div-playlist {
  position: relative;
  display: block;
  max-width: 75%;
  margin-bottom: 50px;
  /* border: 2px solid red; */
}

p {
  color: rgb(32, 32, 32) !important;
  font-size: 1.5rem !important;
}

h1 {
 color: rgb(32, 32, 32);
 font-size: 2rem !important;
 position: absolute;
 line-height: 72px;
 left:-20px;
 top:-20px;
 height: 75px;
 width: 75px;
 padding: 6px;
 background-color: #fff;
 border-radius: 35px;
}
</style>
